import { useEffect, useState } from "react";
import api from "../../../api/api";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import BranchCard from "../../../components/Course/BranchCard";
import CourseCard from "../../../components/Course/CourseCard";
import { useProfileStore } from "../../../store/useUserStore";
import TabHeader from "../../../components/Header/TabHeader";
import { driver } from "driver.js";
import { useLocation } from "react-router-dom";

let initialResults: any = [];

const AcademyBranch = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const { t } = useTranslation();
  const [results, setResults] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const {
    startProgress,
    tickProgress,
    homePageShow,
  } = useProfileStore();

  useEffect(() => {
    if (homePageShow && homePageShow === "school") {
      return navigate("/school");
    } else if (homePageShow && homePageShow === "explore") {
      return navigate("/");
    }
    getBranches();
  }, []);

  useEffect(() => {
    if (searchTerm == "") {
      setResults(initialResults);
    }
  }, [searchTerm]);

  function getBranches() {
    startProgress(1);
    api
      .get(
        `${process.env.REACT_APP_API_BASE_URL}/parent/home/search?mode=academy`,
      )
      .then((res) => {
        console.log("res", res.data.data);
        if (res.data.data.type == "mix") {
          let mRes = res.data.data.items
            .map((item: any) => {
              if (item.type == "branch") {
                return {
                  ...item,
                  type: "branch",
                };
              } else if (item.type == "course") {
                const allDaysSet = new Set<string>();

                // Safely loop through course.schedule
                if (Array.isArray(item.schedule)) {
                  item.schedule.forEach((slot: any) => {
                    const dayLabel = slot?.day?.label;
                    if (dayLabel) {
                      allDaysSet.add(dayLabel);
                    }
                  });
                }

                const dayOrder = [
                  "Monday",
                  "Tuesday",
                  "Wednesday",
                  "Thursday",
                  "Friday",
                  "Saturday",
                  "Sunday",
                ];

                const dayShortMap: { [key: string]: string } = {
                  Monday: "Mon",
                  Tuesday: "Tues",
                  Wednesday: "Wed",
                  Thursday: "Thur",
                  Friday: "Fri",
                  Saturday: "Sat",
                  Sunday: "Sun",
                };
                const sortedDays = dayOrder
                  .filter((day) => allDaysSet.has(day))
                  .map((day) => dayShortMap[day]);

                return {
                  ...item,
                  concatDayArray: sortedDays,
                  type: "course",
                };
              }
            })
            .filter(Boolean); // Removes all undefined/null values
          setResults(mRes);
          initialResults = mRes;
        }
      })
      .catch((err) => {
        console.log("err", err);
        toast.error(t("server_error"));
      })
      .finally(() => {
        tickProgress();
      });
  }

  function search() {
    if (searchTerm == "") return;
    startProgress(1);
    api
      .get(
        `${process.env.REACT_APP_API_BASE_URL}/parent/home/search?mode=academy&query=${searchTerm}`,
      )
      .then((res) => {
        console.log("res", res.data.data);
        if (res.data.data.type == "branch") {
          let mRes = res.data.data.branches.map((c: any) => ({
            ...c,
            type: "branch",
          }));
          setResults(mRes);
        } else if (res.data.data.type == "course") {
          let mRes = res.data.data.courses.map((course: any) => {
            const allDaysSet = new Set<string>();

            // Safely loop through course.schedule
            if (Array.isArray(course.schedule)) {
              course.schedule.forEach((slot: any) => {
                const dayLabel = slot?.day?.label;
                if (dayLabel) {
                  allDaysSet.add(dayLabel);
                }
              });
            }

            const dayOrder = [
              "Monday",
              "Tuesday",
              "Wednesday",
              "Thursday",
              "Friday",
              "Saturday",
              "Sunday",
            ];

            const dayShortMap: { [key: string]: string } = {
              Monday: "Mon",
              Tuesday: "Tues",
              Wednesday: "Wed",
              Thursday: "Thur",
              Friday: "Fri",
              Saturday: "Sat",
              Sunday: "Sun",
            };

            const sortedDays = dayOrder
              .filter((day) => allDaysSet.has(day))
              .map((day) => dayShortMap[day]);

            return {
              ...course,
              concatDayArray: sortedDays,
              type: "course",
            };
          });
          setResults(mRes);
        } else {
          setResults([]);
        }
      })
      .catch((err) => {
        console.log("err", err);
      })
      .finally(() => {
        tickProgress();
      });
  }

  function saveBranchAndNavigate(branch_id: number) {
    startProgress(1);
    api
      .get(
        `${process.env.REACT_APP_API_BASE_URL}/parent/home/search/details?mode=academy&branch_id=${branch_id}&type=branch`,
      )
      .then((res) => {})
      .finally(() => {
        tickProgress();
        return navigate(`/branch/${branch_id}`);
      });
  }

  function saveCourseAndNavigate(course_branch_id: number) {
    startProgress(1);
    api
      .get(
        `${process.env.REACT_APP_API_BASE_URL}/parent/home/search/details?mode=academy&course_branch_id=${course_branch_id}&type=course`,
      )
      .then((res) => {})
      .finally(() => {
        tickProgress();
        return navigate(`/course/${course_branch_id}`);
      });
  }

  return (
    <>
      <TabHeader defaultTab="academy" />
      <div className="mt-4 px-4 mb-12">
        <div className="w-full">
          <div className="flex items-center mb-6">
            <input
              id="course-code-input"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="basis-11/12 bg-gray-200 placeholder:text-slate-400 text-slate-700 text-md border border-slate-200 rounded-l-xl pl-3 py-1 transition duration-300 ease focus:outline-none focus:border-slate-400 hover:border-slate-300 focus:shadow"
              placeholder={t("home.search_branch_id")}
            />

            <button
              onClick={() => {
                search();
              }}
              className="basis-1/12 bg-theme p-2 flex justify-center items-center rounded-r-xl"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="#FFF"
                className="w-5 h-5"
              >
                <path
                  fillRule="evenodd"
                  d="M10.5 3.75a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5ZM2.25 10.5a8.25 8.25 0 1 1 14.59 5.28l4.69 4.69a.75.75 0 1 1-1.06 1.06l-4.69-4.69A8.25 8.25 0 0 1 2.25 10.5Z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          </div>

          {results.length > 0 ? (
            <div className="grid grid-cols-2 gap-2 items-start">
              {results.map((res: any, index: number) => {
                if (res.type == "branch") {
                  return (
                    <BranchCard
                      key={index}
                      branch_id={res.branch_id}
                      name={res.branch_name}
                      images={res.images}
                      saveBranchAndNavigate={(branchId) => {
                        saveBranchAndNavigate(branchId);
                      }}
                      isFull={res.is_full}
                    />
                  );
                } else if (res.type == "course") {
                  
                  return (
                    <CourseCard
                      explore={false}
                      key={index}
                      course_id={res.course_branch_id}
                      name={res.course_name}
                      concatDayArray={res.concatDayArray}
                      images={res.images}
                      pricing_packages={res.pricing_packages}
                      promotions_tag={res.promotions_tag}
                      schedule={res.schedule}
                      saveCourseAndNavigate={(course_branch_id) => {
                        saveCourseAndNavigate(course_branch_id);
                      }}
                      isFull={res.is_full}
                    />
                  );
                }
              })}
            </div>
          ) : (
            <div className="text-center px-10" style={{ height: "60vh" }}>
              <img
                src="/assets/img/academy-default.png"
                alt="No results found"
                className="w-100 h-100 object-contain opacity-70"
              />
              <div className="text-md font-semibold text-theme">
                {t("home.request_code")}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AcademyBranch;
